module.exports = __webpack_public_path__ + "img/new_double_door.cd54151f.png";